import React from "react";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // 2025-10-20
import Login from "./public/login/Login";
import Dashboard from "./private/dashboard/Dashboard";
import Financeiro from "./private/financeiro/Financeiro";
import Outros from "./private/outros/Outros";
import Settings from "./private/settings/Settings";
import Welcome from "./private/welcome/Welcome";

import Inscricoes from "./private/inscricoes/Inscricoes"; // 2025-10-20

function Router() {
  function PrivateRoute({ children }) {

    const isAuth = localStorage.getItem("token") !== null;

    return isAuth ? children : <Navigate to="/" />;
  }

  // 2025-10-20
  function PrivateAdminRoute({ children }) {

    let decoded = null;

    const isAuth = localStorage.getItem("token") !== null;

    if ( isAuth ) decoded = jwtDecode(localStorage.getItem("token"));

    return isAuth ? ( decoded.isAdmin ? children : <Navigate to="/dashboard" /> ) : <Navigate to="/" />;

  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" exact element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/financeiro"
          element={
            <PrivateAdminRoute>
              <Financeiro />
            </PrivateAdminRoute>
          }
        />
        <Route
          path="/outros"
          element={
            <PrivateRoute>
              <Outros />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route
          path="/inscricoes"  // 2025-10-20
          element={
            <PrivateRoute>
              <Inscricoes />
            </PrivateRoute>
          }
        />
        <Route
          path="/welcome"
          element={
            <PrivateRoute>
              <Welcome />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
